/**
 * Enums partagés pour le domaine User
 * Source de vérité unique pour Front & Back
 */

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  DEACTIVATED = 'DEACTIVATED',
}

export enum Theme {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
  SYSTEM = 'SYSTEM',
}

export enum ConsentKind {
  TERMS = 'TERMS',
  TERMS_OF_SERVICE = 'TERMS_OF_SERVICE', // Alias
  PRIVACY = 'PRIVACY',
  PRIVACY_POLICY = 'PRIVACY_POLICY', // Alias
  MARKETING = 'MARKETING',
  ANALYTICS = 'ANALYTICS',
  COOKIES = 'COOKIES',
  DATA_SHARING = 'DATA_SHARING',
  DATA_PROCESSING = 'DATA_PROCESSING',
  AUP = 'AUP',
  CODE_OF_CONDUCT = 'CODE_OF_CONDUCT',
  PARENTAL_CONSENT = 'PARENTAL_CONSENT',
  MEDIA_RELEASE = 'MEDIA_RELEASE',
}

export enum RelationType {
  GUARDIAN_OF = 'GUARDIAN_OF', // parent/tuteur -> élève
  LINKED_ACCOUNT = 'LINKED_ACCOUNT',
  OTHER = 'OTHER',
}

export enum ErasureStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  DONE = 'DONE',
  REJECTED = 'REJECTED',
}
